<template>
  <div class="gui-flex gui-flex-rows">
    <div class="mb-3 no__radius">
      <v-data-table
        :headers="headers"
        :items="items"
        hide-controls
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.datum | formatSimpleDate }}</td>
          <td>{{ props.item.castka | formatMoney }} Kč</td>
          <td>{{ props.item.variabilni_symbol }}</td>
          <td>
            <span v-if="props.item.ucel_pohybu=='vstupni_poplatek'">Vstupní poplatek</span>
            <span v-else-if="props.item.ucel_pohybu=='sporeni'">Spoření</span>
          </td>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      headers: [
        { text: 'Datum', value: 'datum' },
        { text: 'Částka', value: 'castka' },
        { text: 'Variabilní symbol', value: 'variabilni_symbol' },
        { text: 'Účel platby', value: 'variabilni_symbol' }
      ],
      items: [

      ]
    }
  },
  props: {
    id: String,
    program: String
  },
  mounted: function() {
    window.API.get("osoby/"+this.$props.id+"/sporici-programy/"+this.$props.program+"/platby").then(function(body) {
      this.items = body;
    }.bind(this)).catch(function(err) {
      console.log(err);
    }.bind(this));
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Klienti/Platby.vue